import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AbstractControl, UntypedFormControl, Validators } from "@angular/forms";
import { EnderecoService } from "./endereco.service";
import { HelperService } from "src/app/utils/helper.service";
import { SnackBarService } from "src/app/services/snack-bar.service";

@Component({
  selector: 'app-busca-endereco',
  templateUrl: './busca-endereco.component.html',
  styleUrls: ['./busca-endereco.component.css'],
})
export class BuscaEnderecoComponent implements OnInit, OnChanges {
  @Output() endereco = new EventEmitter<any>();
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() cadastroNovo: boolean = true;
  @Input() icon: string = 'search';
  @Input() label: string = 'CEP';
  @Input() appearance: 'fill' | 'outline' = 'outline';
  @Input() inputClasses: string = '';
  @Input() buttonTooltip: string = 'Buscar endereço';
  @Input() toolTip: string = '';
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' | 'before' | 'after' = 'after';

  @ViewChild('input') inputElement!: ElementRef;

  // 💡 Modificação aqui: CEP agora é recebido como um controle externo (Input)
  @Input() control!: AbstractControl | null;

  // Mantemos este como fallback ou ponte de tipagem para o HTML
  cepForm!: UntypedFormControl;
  isProgress: boolean = false;

  constructor(
    private enderecoService: EnderecoService,
    private helper: HelperService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    // Se um controle foi passado via Input, usamos ele. Caso contrário, criamos um localmente.
    this.cepForm = (this.control as UntypedFormControl) || new UntypedFormControl(null);

    // Adiciona as validações caso elas já não tenham sido declaradas no componente pai
    const validadorCep = (control: AbstractControl) => {
      return this.helper?.cepValidator ? this.helper.cepValidator(control) : null;
    };

    // Mescla os validadores existentes com os obrigatórios do CEP
    const validadoresAtuais = this.cepForm.validator ? [this.cepForm.validator] : [];
    this.cepForm.setValidators([...validadoresAtuais, Validators.required, validadorCep]);
    this.cepForm.updateValueAndValidity();

    if (this.disabled) {
      this.cepForm.disable();
    }
  }

  public getForm(): UntypedFormControl {
    return this.cepForm;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Sincroniza o controle recebido dinamicamente se o Input mudar
    if (changes.control && changes.control.currentValue) {
      this.cepForm = changes.control.currentValue as UntypedFormControl;
    }

    if (changes.disabled && this.cepForm) {
      if (changes.disabled.currentValue) {
        this.cepForm.disable();
      } else {
        this.cepForm.enable();
      }
    }
  }

  getEndereco(cep: string): void {
    if (this.cepForm.invalid) {
      this.cepForm.markAsTouched();
      return;
    }

    const cepLimpo = cep ? cep.replace(/\D/g, '') : '';

    this.isProgress = true;
    this.cepForm.disable();

    this.enderecoService.buscaEndereco(cepLimpo)
      .subscribe({
        next: (res: any) => {
          this.isProgress = false;
          if (!this.disabled) {
            this.cepForm.enable();
          }
          this.focusInput();

          if (res) {
            this.endereco.emit(res);
          } else {
            this.snackBar.showSnackBarError('Endereço não localizado.');
          }
        },
        error: (error) => {
          this.isProgress = false;
          if (!this.disabled) {
            this.cepForm.enable();
          }
          this.focusInput();
          console.error(error);
          this.snackBar.showSnackBarError('Endereço não encontrado, é necessário cadastrar.');
        }
      });
  }

  keyPressSubmit(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      this.getEndereco(this.cepForm.value);
    }
  }

  onBlur(): void {
    if (this.cepForm.value) {
      this.cepForm.updateValueAndValidity();
    }
  }

  isFocused(element: HTMLInputElement): boolean {
    return document.activeElement === element;
  }

  private focusInput(): void {
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.focus();
    }
  }
}
